import { Injectable } from '@angular/core';
import { ApiService } from 'core/api/api.service';
import { AccountNote } from '../entities/accountNote';

@Injectable({
  providedIn: 'root'
})
export class NotesWidgetService {
  private urlAccountsNotes = '/api/account/notes/list/';
  private urlDeleteAccountsNotes = '/api/account/notes/delete';
  private urlSaveAccountsNotes = '/api/account/notes/create';

  constructor(
    public apiService: ApiService
  ) { }

  /**
   * Getting notes for an account
   * @param accountId account id
   * @param callback callback
   * @param errorCallback callback invoked when the request fails
   */
  getAccountNotes(accountId: string, callback: (...args: any[]) => any, errorCallback?: () => void) {
    this.apiService.get(this.urlAccountsNotes + accountId).subscribe({
      next: (values: AccountNote[]) => callback(values),
      error: () => errorCallback?.()
    });
  }

  /**
   * Deleting an account note
   * @param id note id
   */
  deleteAccountsNotes(noteId: string, accountId?: string, propagateUpdate = false) {
    return this.apiService.post(this.urlDeleteAccountsNotes, { noteId, accountId, propagateUpdate });
  }

  /**
   * Save an account note
   * @param accountId account id
   * @param noteText note content
   */
  saveAccountsNotes(accountId: string, noteText: string, propagateUpdate = false) {
    return this.apiService.post(this.urlSaveAccountsNotes, { accountId, noteText, propagateUpdate });
  }
}
